// extracted by mini-css-extract-plugin
module.exports = {"root":"IconFilter_root__3Yzpu"};